"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = require("@hh.ru/analytics-js");
/** Событие отправляется, когда пользователь изменил Видимость резюме. */
const resumeEditVisibilityExternal = ({ label }) => analytics_js_1.VendorAnalytics.eventToStorage("applicant", "resume-edit", label);
exports.default = resumeEditVisibilityExternal;
